export default "__VITE_ASSET__BVOkCEI$__"